// Base URL for the Funooni REST API.
//
// This is a deliberate DUPLICATE of `hostURL` in src/services/data_requests.jsx.
// Importing it from there instead would drag the shared layer into the existing
// AuthContext -> data_requests -> useAuth cycle, so the new architecture keeps
// its own copy. The two are reconciled in the post-extraction maintenance pass.
//
// Note the trailing slash: axios `baseURL` concatenation means every path in
// this codebase must be written WITHOUT a leading slash (`apiClient.get("user")`),
// otherwise the URL ends up with a double slash.
export const API_BASE_URL = "https://api.funooni.com/";
